import {Component, Injector, OnInit} from "@angular/core";
import {
    APPLICATION_SCOPE_TYPE, ITCIAppFeatureService,
    ITCIApplication,
    ITCIApplicationAuth,
    ITCITenantComponentOptions,
    ITCIUserInfo,
    TCI_APP_DETAIL_MENU_TYPE,
    TCI_COMPONENT_MODE,
    TCITenantAppType,
    TCITenantSelectorType,
    ITCIEnvVars
} from "@tci/common";

import {
    ITCIAppDetailsLiveStatsComponentInput,
    ITCIAppDetailsLiveStatsComponentOutput,
    TCITenantComponentInput,
    TCITenantComponentOutput
} from "../../ng-tenant/tci-tenant-components";
import {AbstractTCITenantComponent} from "../../ng-tenant/tci-tenant-component";
import {NgUserService} from "../../ng-shared/ng-services/ng-user.service";
import {Observable} from "rxjs";
import {NgAppFeatureToggleService} from "../../ng-shared/ng-services/ng-app-feature-toggle.service";
import {NgEnvVarsService} from "../../ng-shared/ng-services/ng-env-vars.service";

export class BaseAppDetailLiveStatsComponentInput extends TCITenantComponentInput
    implements ITCIAppDetailsLiveStatsComponentInput {

    /**
     *
     * @param tenantAppType
     * @param componentSelector
     * @param application
     * @param userService
     * @param featureToggleService
     * @param mode
     * @param componentOption
     */
    constructor(
        public tenantAppType: TCITenantAppType,
        public componentSelector: TCITenantSelectorType,
        public application: ITCIApplication,
        public userService: NgUserService,
        public featureToggleService: NgAppFeatureToggleService,
        public mode: TCI_COMPONENT_MODE | string,
        public componentOption?: ITCITenantComponentOptions<TCI_APP_DETAIL_MENU_TYPE>) {
        super();
        if (!mode) {
            this.mode = TCI_COMPONENT_MODE.COMP_MODE_APP_DEFAULT;
        }
    }


    getApplication(): ITCIApplication {
        return this.application;
    }

    getAuthForFunction(scope: APPLICATION_SCOPE_TYPE | string): Observable<ITCIApplicationAuth> {
        return this.userService.getAuthForFunction(scope);
    }

    getUserInfo(): Observable<ITCIUserInfo> {
        return this.userService.getUserInfo(false);
    }


    getFeatureToggleService(): ITCIAppFeatureService {
        return this.featureToggleService;
    }

    getEnvVar(injector: Injector, ...envVarNames: string[]): Observable<ITCIEnvVars<any>> {
        return (<NgEnvVarsService>injector.get(NgEnvVarsService)).getEnvVar(...envVarNames);
    }
}

export class BaseAppDetailLiveStatsComponentOutput<E> extends TCITenantComponentOutput<E>
    implements ITCIAppDetailsLiveStatsComponentOutput<E> {
    constructor() {
        super();
    }
}

@Component({
    selector: TCITenantSelectorType.TCI_APP_DETAIL_PANEL_LIVE_STATS.toString(),
    template: `
        <div id="app-details-live-stats-{{input?.application.id}}"></div>`
})
export class BaseAppDetailLiveStatsComponent<E,
    I extends ITCIAppDetailsLiveStatsComponentInput, O extends ITCIAppDetailsLiveStatsComponentOutput<E>>
    extends AbstractTCITenantComponent<E, I, O>
    implements OnInit {

    constructor() {
        super();
    }

    ngOnInit(): void {
    }
}
